<template>
  <div v-show="is_show_filter" :class="class_" :style="advanced?'':'display:block'">
    <div class="works-filter__block-item">
      <div class="works-filter__block-title">{{ $t("message.Price") }}</div>
    </div>

    <ul class="works-filter__select">
      <li v-for="(val, index) in values">
        <input class="works-filter__select-input" type="radio" name="cost" :id="'id_filter_'+val.value" v-model="currency" :value="val"/>
        <label class="works-filter__select-label" :class="(currency.value==val.value)?'active':''" :for="'id_filter_'+val.value">{{ val.label_text }}</label>
      </li>
    </ul>

    <div class="slider__list-container">
      <div class="dropdown-list__wrapper" style="overflow: visible">
        <div class="range-slider c_ui7" ref="price_range"></div>
        <div class="range-slider__nav">
          <div class="range-slider__scale">
            <div class="range-slider__scale-point">
              <div class="range-slider__scale-item">&nbsp;</div>
            </div>
          </div>
          <div class="range-slider__scale">
            <div class="range-slider__scale-point">
              <div class="range-slider__scale-item">{{ cur_from }}</div>
            </div>
          </div>
          <div class="range-slider__scale">
            <div class="range-slider__scale-point">
              <div class="range-slider__scale-item">{{ cur_to }}</div>
            </div>
          </div>
          <div class="range-slider__scale">
            <div class="range-slider__scale-point">
              <div class="range-slider__scale-item">&nbsp;</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- нужно, чтобы updated срабатывал, там мы устанавливаем новые границы для слайдера -->
    <!-- костыльное решение -->
    <div style="display: none">
      =={{ min_from }}, {{ max_to }}, {{ price_min }}, {{ price_max }}==
    </div>

  </div>
</template>


<script>
  import dropdownSub from "../../../../_common/components/lib/dropdownSub";
  import FilterPriceMix from "../../../../../components/list/filter/FilterPriceMix";

  export default {
    components: { dropdownSub },
    name      : 'filter-price-sub',
    props:{
      is_show: { type: Boolean, default: true },
    },
    mixins: [FilterPriceMix],
    data() {
      return {
        cur_from: 0,
        cur_to: 0,
        T_update:null,
        T_create: null,
        is_real_update: true,//чтобы не отправлять запросы, когда меняется конфигурация слайдера
        is_slider_created: false,
        is_currency_slider: true,
      }
    },

    created() {
      this.$store.dispatch ('addUsedFilters', 'Prices');

      this.values = [
        this.valuesObj['USD'],
        this.valuesObj['EURO'],
        this.valuesObj['RUR'],
        //this.valuesObj['UAH'],
      ];
    },

    methods: {
      on_periodChange: function(price_min, price_max){
        /*price_min=this.price_min_in;
        price_max=this.price_max_in;*/

        if ( this.is_curr_changed ) return;
        //console.log('in', price_min, price_max);

        let o_slider=this.$refs.price_range;
        if ( !this.is_slider_created || o_slider.noUiSlider==null ) return;

        if ( price_min===false || price_min==='' || price_min===undefined ) price_min=this.min_from;
        if ( price_max===false || price_max==='' || price_max===undefined ) price_max=this.max_to;

        if ( price_min!=null && price_min==this.cur_from ) return;
        if ( price_max!=null && price_max==this.cur_to ) return;
        /*let values=o_slider.noUiSlider.get();
        let c_min=parseInt(values[0]);
        let c_max=parseInt(values[1]);
        if ( price_min!=null && price_min==c_min ) return;
        if ( price_max!=null && price_max==c_max ) return;*/

        //console.log('out', price_min, price_max);
        this.is_real_update=false;
        o_slider.noUiSlider.set([price_min, price_max]);
        this.is_real_update=true;
      },

      create_slider: function(){
        if ( this.is_slider_created ) return;

        if ( !this.is_show_filter ){
          clearTimeout( this.T_create );
          this.T_create=setTimeout( ()=>{ this.create_slider() }, 500 );
          return;
        }

        this.is_slider_created=true;
        let this_=this;
        this.$nextTick(()=>{
          let set_from=this_.price_min_in;
          let set_to=this_.price_max_in;

          let min_from=this_.min_from;
          let max_to=this_.max_to;
          if ( min_from==max_to ) max_to=min_from+1;

          if ( set_from==null ) set_from=min_from;
          if ( set_to==null ) set_to=max_to;

          let o_slider=this_.$refs.price_range;

          this_.cur_from=set_from;
          this_.cur_to=set_to;
          window.noUiSlider.create(o_slider, {
            start: [parseInt(set_from), parseInt(set_to)],
            connect: true,
            //direction: 'ltr',
            //step: 1,
            format: wNumb({
              decimals: 0
            }),
            range: {
              'min': parseInt(min_from),
              'max': parseInt(max_to),
            }
          });

          o_slider.noUiSlider.on('update', function( values, handle ) {
            this_.cur_from=values[0];
            this_.cur_to=values[1];

            if ( !this_.is_real_update ) return;

            clearTimeout(this.T_update);
            this.T_update=setTimeout( function(){
              let set_from=this_.cur_from;
              let set_to=this_.cur_to;

              if ( set_from<=this_.min_from ) set_from='';
              if ( set_to>=this_.max_to ) set_to='';

              let tmp_from=this_.price_min_in;
              if ( tmp_from===undefined ) tmp_from='';
              let tmp_to=this_.price_max_in;
              if ( tmp_to===undefined ) tmp_to='';

              if (set_from!=tmp_from) this_.price_min=set_from;
              if (set_to!=tmp_to) this_.price_max=set_to;
            }, 200 );
          });
        });
      },
    },

    updated() {
      if ( !this.is_slider_created ){
        this.create_slider();
      }
      else {
        this.$nextTick( ()=>{
          let o_slider=this.$refs.price_range;
          if ( o_slider.noUiSlider==null ) return;
          if ( o_slider.noUiSlider.options.range.min==parseInt(this.min_from) && o_slider.noUiSlider.options.range.max==parseInt(this.max_to) ) return;
          if ( this.min_from==this.max_to ) return;

          this.is_curr_changed=false;

          this.is_real_update=false;
            let set_from=this.min_from;
            let set_to=this.max_to;

            this.cur_from=set_from;
            this.cur_to=set_to;
            o_slider.noUiSlider.updateOptions({
              start: [set_from, set_to],
              range: {
                'min': parseInt(this.min_from),
                'max': parseInt(this.max_to)
              }
            });
          this.is_real_update=true;
        } );
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/sub/air_light/components/list/filter/FilterPriceSub.vue